(function () {
  'use strict';

  angular
    .module('checker.core')
    .constant('API_META', {
      // English
      'INTERACTIONS_ENDPOINT_EN': '/api/v1/interactions',
      'VIEW_ALL_ENDPOINT': '/api/v1/view_all_interactions',
      'DRUGS_ENDPOINT_EN': '/api/v1/drugs',
      'DRUG_CLASSES_ENDPOINT_EN': '/api/v1/drug_classes',
      'COMEDS_ENDPOINT_EN': '/api/v1/comeds',
      'COMED_CLASSES_ENDPOINT_EN': '/api/v1/comed_classes',
      'UNAPPROVED_AND_PRIMARY_ENDPOINT': '/api/v1/unapproved_and_primary',
      'UNAPPROVED_AND_COMED_ENDPOINT': '/api/v1/unapproved_and_comed',
      'PRIMARY_TRADE_NAMES_ENDPOINT': '/api/v1/primary_trade_names',
      'COMED_TRADE_NAMES_ENDPOINT': '/api/v1/comed_trade_names',
      'X-Api-Key': '81ef317341cc99f031b16be369d40df6',

      // French
      'DRUGS_ENDPOINT_FR': '/api/v1/drugs?lang=fr',
      'DRUG_CLASSES_ENDPOINT_FR': '/api/v1/drug_classes?lang=fr',
      'COMEDS_ENDPOINT_FR': '/api/v1/comeds?lang=fr',
      'COMED_CLASSES_ENDPOINT_FR': '/api/v1/comed_classes?lang=fr',
      'INTERACTIONS_ENDPOINT_FR': '/api/v1/interactions?lang=fr'
    })
    .constant('GRADES', {
      'es': ["Sin Establecer", "Alta", "Moderada", "Baja", "Muy Baja"],
      'pt': ["Não configurado", "Alto", "Moderado", "Baixo", "Muito Baixo"],
      'fr': ["Non défini", "Haut", "Modéré", "Faible", "Très faible"],
      'en': [ "Not set", "High", "Moderate", "Low", "Very Low"] 
    })
    .constant('SUMMARIES', {
      'es': ["No Coadministrar", "Posible Interacción", "Posible Interacción Débil", "Sin Interacción Esperada"],
      'pt': ["Não Coadministrar", "Interação Potencial", "Possível Interação Fraca", "Não Se Espera Interação"],
      'fr': ["Ne Pas Coadministrer", "Interaction Potentielle", "Interaction Faible Potentielle", "Aucune Interaction Attendue"],
      'en': ["Do Not Coadminister", "Potential Interaction", "Potential Weak Interaction", "No Interaction Expected"]
    });

})();
